/**
 * Beat 8, part 1 — the cull corridor in reverse.
 *
 * This is intentionally only the traversal. The fuse box, hens and Otto's
 * emptied pen belong to part 2; making this file know any of them would make a
 * room hand-over look like an in-place continuation, which it is not.
 */

import type { Beat, Stage, StoryContext } from '@/story/types';

export const BLACKOUT_RETURN_FLAGS = {
  /** The old entrance is ahead of her again. Raised by the cull room's spatial seam. */
  atExit: 'blackout-return.atExit',
} as const;

export const BLACKOUT_RETURN_CUES = {
  /** Fade the return state in once its world is complete. */
  open: 'blackout-return.open',
  /** The door ahead ends this part; the next room owns the following reveal. */
  fadeOut: 'blackout-return.fadeOut',
  end: 'blackout-return.end',
} as const;

/**
 * The player has ample time to cross, but standing still can never make an Act
 * 2 boot permanent. The spatial flag is the early exit; this is the backstop.
 */
export const RETURN_PATIENCE = 35;
const FADE_SECONDS = 4;

function waitForExit(): Stage {
  return {
    id: 'return',
    enter: (_ctx, emit): void => emit(BLACKOUT_RETURN_CUES.open),
    done: (ctx: StoryContext): boolean => (
      ctx.completed.has(BLACKOUT_RETURN_FLAGS.atExit) || ctx.stageTime >= RETURN_PATIENCE
    ),
  };
}

export const BLACKOUT_RETURN_BEAT: Beat = {
  number: 8,
  id: 'act2.blackoutReturn',
  stages: [
    waitForExit(),
    {
      id: 'close',
      enter: (_ctx, emit): void => emit(BLACKOUT_RETURN_CUES.fadeOut),
      done: (ctx: StoryContext): boolean => ctx.stageTime >= FADE_SECONDS,
      exit: (_ctx, emit): void => emit(BLACKOUT_RETURN_CUES.end),
    },
  ],
};
